'use strict'

import { loadComponent } from './utils/load-component';

loadComponent('digital-subscription', {
    props: {
        subscription: {
            type: Object,
        },
    },

    data() {
        return {
            ViewModel: {
                Link: this.subscription.PackageLink,
                ListingImage: this.subscription.Image,
                Prefix: this.subscription.Prefix,
                Title: this.subscription.Title,
            },
        }
    },
});
